module.exports = __webpack_public_path__ + "img/hotproduct-2.3869998c.jpg";